<!-- 作业列表 -->
<template>
  <div v-loading="loading" class="homeword">
    <div class="boxlistTit">
      <el-form ref="search" :model="condition" class="fl">
        <!-- <Form ref="search" :model="condition" inline class="fl"> -->
        <!-- <Select v-model="paramCourseWork.courseId" placeholder="授课班级">
            <Option :value="0">全部</Option>
            <Option v-for="item in teachingClass" :key="item.id" :value="item.id">{{item.name}}</Option>
        </Select>-->
        <el-select v-model="paramCourseWork.courseId" placeholder="授课班级">
          <el-option :value="0" label="全部"></el-option>
          <el-option
            v-for="item in teachingClass"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <Select v-model="condition.software" placeholder="应用软件">
            <Option value="1">AT</Option>
            <Option value="2">AFM</Option>
        </Select>-->
        <el-select v-model="paramCourseWork.softwareType" placeholder="应用软件" style="margin:0 10px;">
          <el-option :value="0" label="全部"></el-option>
          <el-option :value="1" label="AT"></el-option>
          <el-option :value="2" label="AFM"></el-option>
          <el-option :value="3" label="其它"></el-option>
        </el-select>
        <el-select v-model="paramCourseWork.status" placeholder="完成方式">
          <el-option :value="0" label="全部"></el-option>
          <el-option :value="1" label="未下发"></el-option>
          <el-option :value="2" label="已下发"></el-option>
          <el-option :value="3" label="已截止"></el-option>
        </el-select>
        <el-input
          type="name"
          v-model="paramCourseWork.name"
          placeholder="作业标题"
          style="width:280px;margin:0 10px"
        ></el-input>
        <el-button type="primary" @click="ngOnInit">查询</el-button>
      </el-form>
      <router-link
        :to="`/teacherManage`"
        style="margin-left:10px"
        class="fr"
      >
        <el-button type="primary">返回</el-button>
      </router-link>
      <router-link
        :to="`/alliance/teacher/${$route.query.schoolId}/homework/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}&type=1`"
      >
        <el-button type="primary" class="fr">新建</el-button>
      </router-link>
    </div>

    <el-table :data="homeworkList">
      <el-table-column prop="courseWorkName" label="作业标题"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">未下发</span>
          <span v-if="scope.row.status == 2">已下发</span>
          <span v-if="scope.row.status == 3">已截止</span>
        </template>
      </el-table-column>
      <el-table-column label="成绩状况">
        <template slot-scope="scope">
          <span v-if="scope.row.publishStatus == true">已公布成绩</span>
          <span v-if="scope.row.publishStatus == false">未公布成绩</span>
        </template>
      </el-table-column>
      <el-table-column label="提交情况">
        <template slot-scope="scope">
          <span>{{scope.row.committed}}/{{scope.row.needCommit}}</span>
        </template>
      </el-table-column>
      <el-table-column label="待批改">
        <template slot-scope="scope">
          <!-- true未批改    reviewed	已批改 ,committed已提交 -->
          <el-badge
            is-dot
            :hidden="!scope.row.hasUnReview"
            style="margin-top: 10px;"
          >{{Number(scope.row.committed)-Number(scope.row.reviewed)}}</el-badge>
        </template>
      </el-table-column>
      <el-table-column prop="publishDate" label="发布时间"></el-table-column>
      <el-table-column prop="deadLine" label="截止时间"></el-table-column>
      <el-table-column label="应用软件">
        <template slot-scope="scope">
          <span v-if="scope.row.softwareType == 1">AT</span>
          <span v-if="scope.row.softwareType == 2">AFM</span>
          <span v-if="scope.row.softwareType == 3">其它</span>
        </template>
      </el-table-column>
      <el-table-column label="完成方式">
        <template slot-scope="scope">
          <span v-if="scope.row.workType == 1">个人</span>
          <span v-if="scope.row.workType == 2">小组</span>
        </template>
      </el-table-column>
      <el-table-column prop="courseName" label="授课班级"></el-table-column>
      <el-table-column label="平均分">
        <template slot-scope="{row}">{{(Number(row.average)).toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="通过率">
        <template slot-scope="{row}">{{Number(row.passRate.toFixed(2))*100}}%</template>
      </el-table-column>
      <!-- <el-table-column prop="courseWareId" label="课程ID"></el-table-column> -->
      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <div>
            <router-link
              v-if="scope.row.status == 1"
              :to="`/alliance/teacher/${$route.query.schoolId}/homework/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}&courseWorkId=${scope.row.courseWorkId}&type=1`"
            >
              <el-button type="primary" size="small">编辑</el-button>
            </router-link>
            <el-button
              type="primary"
              size="small"
              v-if="scope.row.status == 1"
              @click="issue(scope.row)"
            >下发作业</el-button>
            <!-- <el-button type="primary" size="small" @click="editClass(scope)">修改可见班级</el-button> -->
            <el-button
              type="primary"
              size="small"
              @click="publishStatus(scope.row)"
              v-if="scope.row.publishStatus==false&&scope.row.status == 3"
            >公布</el-button>
            <router-link
              v-if="scope.row.status != 1"
              :to="`/alliance/teacher/${$route.query.schoolId}/homework/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}&courseWorkId=${scope.row.courseWorkId}&type=2`"
            >
              <el-button type="primary" size="small">完成情况</el-button>
            </router-link>
            <el-button size="small" @click="download(scope.row)">下载</el-button>
            <el-button
              type="danger"
              size="small"
              @click="delCourse(scope.row,true)"
              v-if="scope.row.status == 1"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="foot-pager"
      :page-size="10"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="paramCourseWork.startIndex"
      @current-change="ngOnInit"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paramSummary: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      total: 0,
      loading: false,
      homeworkList: [],
      condition: {},
      teachingClass: [],
      paramCourseWork: {
        courseId: 0, // 授课班级id
        name: "", // 作业标题
        now: null, //
        showItem: 10,
        schoolId: this.$route.query.schoolId,
        softwareType: 0, // 应用软件 0:全部 1:at 2:afm
        pageIndex: 1,
        status: 0, // 状态 1：未下发 2：已下发 3：已截止
        teacherId: this.$route.query.teacherId,
        workType: 0, //完成方式 0:全部 1:个人 2:小组
      },
    };
  },
  created() {
    this.ngOnInit();
    this.summarylist();
  },
  methods: {
    issue(item) {
      this.$confirm("您确认下发作业吗？", "下发作业", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          schoolId: this.$route.query.schoolId,
          workId: item.courseWorkId,
        };
        this.$api.allianceSchool.publishCourseWork(param).then((res) => {
          if (res.errCode == 0) {
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    publishStatus(item) {
      this.$confirm("您确认公布成绩吗？", "公布成绩", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          schoolId: this.$route.query.schoolId,
          workId: item.courseWorkId,
        };
        this.$api.allianceSchool.publishWorkScore(param).then((res) => {
          if (res.errCode == 0) {
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 下载文件
    download(item) {
      const param = {
        schoolId: this.$route.query.schoolId,
        workId: item.courseWorkId,
      };
      this.$api.allianceSchool.getCourseWorkInfo(param).then((res) => {
        if (res.errCode == 0) {
          window.location.href = res.data.attachments[0].url;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 删除
    delCourse(item) {
      this.$confirm("您确认删除该作业吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          schoolId: this.$route.query.schoolId,
          workId: item.courseWorkId,
        };
        this.$api.allianceSchool.delCourseWork(param).then((res) => {
          if (res.errCode == 0) {
            this.paramCourseWork.startIndex = 1;
            this.$message.success("删除成功");
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 页面初始化
    ngOnInit() {
      this.loading = true;
      this.$api.allianceSchool
        .queryCourseWorkList(this.paramCourseWork)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.homeworkList = res.data.items || [];
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    summarylist() {
      // 获取可见授课班级
      this.loading = true;
      this.$api.allianceSchool
        .getCourseSummaryList(this.paramSummary)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.teachingClass = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang='less' scoped>
.foot-pager {
  text-align: center;
}
.homeword {
  .el-button + .el-button {
    margin-left: 0;
  }
}
</style>